/* src/app/shared/fvp-modal/fvp-modal.component.scss */
#fvp-message-modal .footer-btn-ok {
  border-color: grey;
  background-color: #2a71bf;
  color: #fff;
  margin-top: -15px;
  height: 30px;
  padding-top: 3px;
  font-size: 13px;
}
#fvp-message-modal .footer-div {
  margin-top: -23px;
}
#fvp-message-modal .footer-container {
  margin-left: 110px;
  height: 11px;
}
#fvp-message-modal .content-font {
  font-size: 13.5px;
}
#fvp-message-modal .content-align {
  text-align: center;
}
#fvp-message-modal .modal-dialog-width {
  width: 520px !important;
}
#fvp-message-modal .btn-msg-cancel {
  margin-left: 12px;
}
#fvp-input-modal .footer-btn {
  border-color: grey;
  background-color: #2a71bf;
  color: #fff;
}
#fvp-input-modal .footer-btn-cancel {
  margin-left: 21px;
}
#fvp-input-modal .footer-container-pos {
  margin-left: 300px;
}
#fvp-input-modal .content-input {
  margin-left: 5px;
}
#fvp-input-modal .content-font {
  font-size: 13.5px;
}
#fvp-input-modal .title-color {
  color: #fff;
}
#fvp-input-modal .no-input-error {
  color: red;
  font-size: 12px;
  margin-left: 137px;
  float: left;
}
#fvp-input-modal .header-background {
  background-color: #2a71bf;
}
/*# sourceMappingURL=fvp-modal.component-LJLTLIUH.css.map */
